import { Button, CircularProgress, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import { auth } from "../../firebase";
import { addUser } from "../../redux/actionProvider";
import "./Login.css";

function Login({ AddUserDispatch }) {
  const [loading, setLoading] = useState(false);
  const [emaill, setEmaill] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const history = useHistory();

  const loginHandler = (e) => {
    setLoading(true);
    e.preventDefault();
    auth
      .signInWithEmailAndPassword(emaill, password)
      .then((userCred) => {
        AddUserDispatch(userCred.user);
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setError(e.code);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (auth.currentUser) {
      history.push("/Home");
    }
    // console.log(auth.currentUser);

    //eslint-disable-next-line
  }, []);

  // console.log(auth.currentUser);

  return (
    <div className="login">
      <form onSubmit={loginHandler} className="login__form">
        <h1 style={{ borderBottom: "1px solid #adadad", color: "#f76b1c" }}>
          Login to continue
        </h1>
        <TextField
          label="Email"
          error={error ? true : false}
          onChange={(e) => {
            setEmaill(e.target.value);
            setError("");
          }}
          value={emaill}
        />
        <TextField
          label="Password"
          type="password"
          error={error ? true : false}
          onChange={(e) => {
            setPassword(e.target.value);
            setError("");
          }}
          value={password}
        />
        <div className="login__btn">
          {loading ? (
            <CircularProgress />
          ) : (
            <Button type="submit" variant="contained" color="primary">
              Submit
            </Button>
          )}
        </div>

        {error ? (
          <div className="login__error">
            <p>
              <b>Error: </b>
              {error}
            </p>
          </div>
        ) : null}
      </form>
    </div>
  );
}

const mapStateToProp = (state) => {
  return {
    UserState: state.User.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    AddUserDispatch: (user) => dispatch(addUser(user)),
  };
};

export default connect(mapStateToProp, mapDispatchToProps)(Login);
